import { render, staticRenderFns } from "./unlock.vue?vue&type=template&id=124c81aa&scoped=true&"
import script from "./unlock.vue?vue&type=script&lang=js&"
export * from "./unlock.vue?vue&type=script&lang=js&"
import style0 from "./unlock.vue?vue&type=style&index=0&id=124c81aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124c81aa",
  null
  
)

export default component.exports